module.exports = __webpack_public_path__ + "static/media/more-icon.9caa098c.svg";